import Zoom from "chartjs-plugin-zoom";

// 바 차트
export const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  animation: {
      duration: 2000
  },
  maxBarThickness: 65, // 막대 굵기
  scales: {
      x: {
        grid: {
            drawOnChartArea: false // 이 축의 그리드 라인은 숨기기
        },
        stacked: false,
        ticks: {
            // 보이는 갯수 제한하기 autoSkip, maxTrickLimit 
            autoSkip: true,
            // maxTicksLimit:5,
            maxRotation: 0,
            minRotation: 0,
            display: true,
            padding: 5,
            font: {
              family: "'Pretendard'",
              size:15,
            }
        }
      },
      y: {
        ticks: {
          font: {
            family: "'Pretendard'",
            size:13
          }
        },
      },
  },
  interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
  },
  elements: {
      point: {	/* 표시자 옵션 */
          pointStyle: 'rectRounded',
          pointRadius: 0, 
          lineTension:1, 
          pointBorderWidth: 0, 
      },
  },
  plugins: {
    legend: {
        display:false,
        // position: 'bottom',
        // labels: {
        //   usePointStyle: true,

        //   font: {
        //     size:14,
        //     family: "'Pretendard'",
        //     lineHeight: 1
        //   },
        // },

      },
      tooltip: {
        backgroundColor: 'rgba(0, 91, 150, 0.8)',  // 툴팁 배경색
        padding:20,
        titleFont: {
            size: 18,  // 툴팁 제목 폰트 크기
            family: "'Pretendard'",
            lineHeight: 1
        },
        bodyFont: {
            size: 17,  // 툴팁 본문 폰트 크기
            family: "'Pretendard'",
            lineHeight: 1,
        }
      },
      hover: {
          animationDuration: 400,
          axis: 'x',
          intersect: true,
          mode: 'label',
          onHover: null
      },
  },
};

//라인차트
export const lineChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  animation: {
      duration: 2000
  },
  maxBarThickness: 65, // 막대 굵기
  scales: {
      x: {
        grid: {
            drawOnChartArea: false // 이 축의 그리드 라인은 숨기기
        },
        stacked: true,
        ticks: {
            // 보이는 갯수 제한하기 autoSkip, maxTrickLimit 
            autoSkip: true,
            // maxTicksLimit:5,
            maxRotation: 0,
            minRotation: 0,
            display: true,
            padding: 5,
            font: {
              family: "'Pretendard'",
              size:15,
            }
        }
      },
      y: {
        ticks: {
          callback: function(value) {
            const label = this.chart?.data?.datasets?.length > 0 
            ? this.chart.data.datasets[0]?.label || 'default' 
            : 'default';

            // console.log(label)
            if(label == '모돈'){
              return value +'두';
            }else if(label == '1+'){
              return value +'두';
            }else{
              return value+'원'
            }
          },
          font: {
            family: "'Pretendard'",
            size:13
          }
          
        },
      },
  },
  interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
  },
  elements: {
      point: {	/* 표시자 옵션 */
          pointStyle: 'rectRounded',
          pointRadius: 0, 
          lineTension:1, 
          pointBorderWidth: 0, 
      },
  },
  plugins: {
    legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,

          font: {
            size:14,
            family: "'Pretendard'",
            lineHeight: 1
          },
        },

      },
      tooltip: {
        backgroundColor: 'rgba(0, 91, 150, 0.8)',  // 툴팁 배경색
        padding:20,
        titleFont: {
            size: 18,  // 툴팁 제목 폰트 크기
            family: "'Pretendard'",
            lineHeight: 1
        },
        bodyFont: {
            size: 17,  // 툴팁 본문 폰트 크기
            family: "'Pretendard'",
            lineHeight: 1,
        }
      },
      hover: {
          animationDuration: 400,
          axis: 'x',
          intersect: true,
          mode: 'label',
          onHover: null
      },
  },
};

// 바, 라인 복합 차트
export const lineBarOptions = {
  responsive: true,
  aspectRatio: 1,
  maintainAspectRatio: false,
  animation: {
    duration: 2000
  },
  plugins: {
    tooltip: {
        backgroundColor: 'rgba(0, 91, 150, 0.8)',  // 툴팁 배경색
        padding:15,
        titleFont: {
            size: 18,  // 툴팁 제목 폰트 크기
            family: "'Pretendard'",
            lineHeight: 1
        },
        bodyFont: {
            size: 17,  // 툴팁 본문 폰트 크기
            family: "'Pretendard'",
            lineHeight: 1,
        },
        callbacks: {
          label: function(tooltipItem) {
              let label = tooltipItem.dataset.label || '';
              let value = tooltipItem.raw;

              // 온도 데이터인 경우에만 '℃'를 붙임
              if (label.includes('온도')) {
                  value += '℃';
              }else if(label.includes('습도')){
                  value += '%';
              }else if(label.includes('기압')){
                  value += 'hPa';
              }else if(label.includes('풍속')){
                  value += 'm/s';
              }else if(label.includes('가격')){
                  value += '원'
              }else if(label.includes('거래')){
                value += '두'
              }else if(label.includes('착유횟수')){
                value += '회'
              }else if(label.includes('착유량')){
                value += 'kg'
              }else if(label.includes('전력')){
                value += 'kWh'
              }else if(label.includes('유단백')){
                value += '%'
              }else if(label.includes('유지방')){
                value += '%'
              }else {
                value += ''
              }
              return label + ': ' + value;
          },
      },
      },
    legend: {
        display: false,
    }
  },
  scales: {
    x: {
    grid: {
        drawOnChartArea: false // 이 축의 그리드 라인은 숨기기
    },
    ticks: {
        autoSkip: true,
        maxTicksLimit:8,
        maxRotation: 0,
        minRotation: 0,
        display: true,
        padding: 3,
        font: {
            family: "'Pretendard'",
            size:14,
        }
    },
  },
  'y1': {
    
      type: 'linear',
      position: 'left',
      categoryPercentage: 0.3,
      barPercentage: 0.3,
      maxBarThickness: 40,
      // textStrokeWidth:100,
      ticks: {
        
          callback: function(value) {
            // console.log("현재 차트 데이터셋:", this.chart?.data?.datasets);
            // console.log(this.chart.data.datasets[0])
            // y1 축 데이터에 조건에 따라 단위 추가
            if (this.chart.data.datasets[1].label.includes('온도')) {
              return value + '℃';
            } else if (this.chart.data.datasets[1].label.includes('습도')) {
              return value + '%';
            } else if (this.chart.data.datasets[1].label.includes('기압')) {
              return value + 'hPa';
            }  else if (this.chart.data.datasets[1].label.includes('풍속')) {
              return value + 'm/s';
            } else if (this.chart.data.datasets[1].label.includes('암모니아')) {
              return value + 'ppm';
            } else if (this.chart.data.datasets[1].label.includes('황화수소')) {
              return value + 'ppm';
            } else if (this.chart.data.datasets[0].label.includes('가격')) {
              return value + '원';
            }else if (this.chart.data.datasets[0].label.includes('거래')) {
              return value + '두';
            }else if(this.chart.data.datasets[0].label.includes('착유횟수')){
              return value += '회'
            }else if(this.chart.data.datasets[0].label.includes('유지방')){
              return value +='%'
            }else{
              return value += ''
            }
          },

          display:false.a,
          font: {
              family: "'Pretendard'",
              size:13
          },

          beginAtZero: true,
          suggestedMax: 100,
          
      },
      // afterFit: function(scale) {
      //   scale.width = 75; // Set the desired width
      //   }
    },
    'y2': {
        type: 'linear',
        position: 'right',
        categoryPercentage: 0.1,
        barPercentage: 0.1,
        maxBarThickness: 5,
        ticks: {
          callback: function(value) {
            // console.log("현재 차트 데이터셋:", this.chart?.data?.datasets);
            // console.log(this.chart.data.datasets[1].label)
            // y1 축 데이터에 조건에 따라 단위 추가
            if (this.chart.data.datasets[0].label.includes('온도')) {
              return value + '℃';
            } else if (this.chart.data.datasets[0].label.includes('습도')) {
              return value + '%';
            } else if (this.chart.data.datasets[0].label.includes('기압')) {
              return value + 'hPa';
            }  else if (this.chart.data.datasets[0].label.includes('풍속')) {
              return value + 'm/s';
            } else if (this.chart.data.datasets[0].label.includes('암모니아')) {
              return value + 'ppm';
            } else if (this.chart.data.datasets[0].label.includes('황화수소')) {
              return value + 'ppm';
            }else if (this.chart.data.datasets[1].label.includes('가격')) {
              return value + '원';
            }else if (this.chart.data.datasets[1].label.includes('거래')) {
              return value + '두';
            }else if(this.chart.data.datasets[1].label.includes('착유량')){
              return value += 'kg'
            }else if(this.chart.data.datasets[0].label.includes('전력량')){
              return value +='kWh'
            }else if(this.chart.data.datasets[1].label.includes('유단백')){
              return value +='%'
            }else{
              return value + '';
            }
          },

            display:false.a,
            font: {
                family: "'Pretendard'",
                size:13
            },
            
            beginAtZero: true,
            suggestedMax: 100,
        },
        title: {
        display: true,
        },
        grid: {
        drawOnChartArea: false 
        },
        // afterFit: function(scale) {
        //   scale.width = 80; 
        // }
    }
  },
    interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false
        },
    elements: {
        line: {	/* 선 옵션 */
            borderCapStyle: 'round',
            borderDashOffset: 0,
            borderJoinStyle: 'round',	
            borderWidth: 2.5,
            capBezierPoints: true,
            // fill: true,
            tension: 0.2
        },
        point: {	/* 표시자 옵션 */
            pointStyle: 'rectRounded',
            pointRadius: 0, 
            lineTension:1, 
            pointBorderWidth: 0, 
        },
    },
};


// 라인, 라인 복합차트
export const lineTolineOptions={
  scales: {
    x: {
        grid: {
            drawOnChartArea: false // 이 축의 그리드 라인은 숨기기
        },
        ticks: {
          // 보이는 갯수 제한하기 autoSkip, maxTrickLimit 
          autoSkip: true,
          // maxTicksLimit:5,
          maxRotation: 0,
          minRotation: 0,
          display: true,
          padding: 3,
          font: {
            family: "'Pretendard'",
            size:14,
          }
        }
    },
    'y-axis-1': {
      // display:false,
      type: 'linear',
      position: 'left',
      ticks: {
        display:false.a,
        font: {
          family: "'Pretendard'",
          size:13
        },
        
        beginAtZero: true,
        suggestedMax: 100,
      },
      grid:{
        borderDash: [2, 2], 
      },
      title: {
          display: false,
      }
    },
},
interaction: {
    mode: 'nearest',
    axis: 'x',
    intersect: false
},
elements: {
  line: {	/* 선 옵션 */
          borderCapStyle: 'round',
          borderDashOffset: 0,
          borderJoinStyle: 'round',	
          borderWidth: 3.5,
          capBezierPoints: true,
          fill: true,
          tension: 0.4
      },
      point: {	/* 표시자 옵션 */
          pointStyle: 'rectRounded',
          pointRadius: 0, 
          lineTension:0, 
          pointBorderWidth: 0, 
      },
},
responsive: true,
maintainAspectRatio: false,
plugins: {
  legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,

        font: {
          size:14,
          family: "'Pretendard'",
          lineHeight: 1
        },
      },

    },
    tooltip: {
      backgroundColor: 'rgba(0, 91, 150, 0.8)',  // 툴팁 배경색
      padding:20,
      titleFont: {
          size: 18,  // 툴팁 제목 폰트 크기
          family: "'Pretendard'",
          lineHeight: 1
      },
      bodyFont: {
          size: 17,  // 툴팁 본문 폰트 크기
          family: "'Pretendard'",
          lineHeight: 1,
      }
    },
    hover: {
        animationDuration: 400,
        axis: 'x',
        intersect: true,
        mode: 'label',
        onHover: null
    },
},
}

// 에너지 사용량 차트 옵션
export const lineEnergyOptions={
  scales: {
    x: {
        grid: {
            drawOnChartArea: false
        },
        ticks: {
          // 보이는 갯수 제한하기 autoSkip, maxTrickLimit 
          autoSkip: true,
          // maxTicksLimit:5,
          maxRotation: 0,
          minRotation: 0,
          display: true,
          padding: 3,
          font: {
            family: "'Pretendard'",
            size:14,
          }
        }
    },
    'y-axis-1': {
      // display:false,
      type: 'linear',
      position: 'left',

      ticks: {
        // display:false.a,
        font: {
          family: "'Pretendard'",
          size:13
        },
        
        beginAtZero: true,
        suggestedMax: 100,
      },
      grid:{
        borderDash: [2, 2], 
      },
      title: {
          display: false,
      }
    },
  },
  elements: {
    line: {	/* 선 옵션 */
        borderCapStyle: 'round',	/* 선 마감: butt, round, square */
        borderDashOffset: 0,
        borderJoinStyle: 'round',	/* 꺾이는 부분 모양: miter, bevel, round */
        borderWidth: 3.0,
        capBezierPoints: true,
        fill: true,	/* 선 밑 공간 색으로 채우기 */
        tension: 0.4
    },
    point: {	/* 표시자 옵션 */
        pointStyle: 'circle',	/* circle, cross, corssRot, dash, line, rect, rectRounded, rectRot, start, triangle */
        pointRadius: 0, //point 없게 만들기 0으로 설정
        lineTension:1, //선 곡선모양 0이면 직선
        pointBorderWidth: 2, //포인터 보더사이즈
    },
  },
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,

        font: {
          size:14,
          family: "'Pretendard'",
          lineHeight: 1
        },
      },

    },
    tooltip: {
      backgroundColor: 'rgba(0, 91, 150, 0.8)',  // 툴팁 배경색
      padding:20,
      titleFont: {
          size: 18,  // 툴팁 제목 폰트 크기
          family: "'Pretendard'",
          lineHeight: 1
      },
      bodyFont: {
          size: 17,  // 툴팁 본문 폰트 크기
          family: "'Pretendard'",
          lineHeight: 1,
      }
    },
    hover: {
        animationDuration: 400,
        axis: 'x',
        intersect: true,
        mode: 'label',
        onHover: null
    },
  },
  }

  // 에너지 사용량 차트 옵션
export const dashEnergyOptions={
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
        grid: {
            drawOnChartArea: false
        },
        ticks: {
          // callback: function (value) {
          //   return `${value}`;
          // },
          
          // callback: function(value, index, ticks) {
          //   // x축 값에 단위를 추가
          //   return value + '일';
          // },
          // 보이는 갯수 제한하기 autoSkip, maxTrickLimit 
          autoSkip: true,
          // maxTicksLimit:5,
          maxRotation: 0,
          minRotation: 0,
          display: true,
          padding: 3,
          font: {
            family: "'Pretendard'",
            size:14,
          }
        }
    },
    'y-axis-1': {
      // display:false,
      type: 'linear',
      position: 'left',
      ticks: {
        callback: function(value) {
          // y축 값에 단위를 추가
          return value + 'kWh';
        },

        // display:false.a,
        font: {
          family: "'Pretendard'",
          size:13
        },
        
        beginAtZero: true,
        suggestedMax: 100,
      },
      grid:{
        borderDash: [2, 2], 
      },
      title: {
          display: false,
      }
    },
  },
  elements: {
    line: {	/* 선 옵션 */
        borderCapStyle: 'round',	/* 선 마감: butt, round, square */
        borderDashOffset: 0,
        borderJoinStyle: 'round',	/* 꺾이는 부분 모양: miter, bevel, round */
        borderWidth: 3.0,
        capBezierPoints: true,
        fill: true,	/* 선 밑 공간 색으로 채우기 */
        tension: 0.4
    },
    point: {	/* 표시자 옵션 */
        pointStyle: 'circle',	/* circle, cross, corssRot, dash, line, rect, rectRounded, rectRot, start, triangle */
        pointRadius: 0, //point 없게 만들기 0으로 설정
        lineTension:1, //선 곡선모양 0이면 직선
        pointBorderWidth: 2, //포인터 보더사이즈
    },
  },
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,

        font: {
          size:14,
          family: "'Pretendard'",
          lineHeight: 1
        },
      },

    },
    tooltip: {
      backgroundColor: 'rgba(0, 91, 150, 0.8)',  // 툴팁 배경색
      padding:20,
      titleFont: {
          size: 18,  // 툴팁 제목 폰트 크기
          family: "'Pretendard'",
          lineHeight: 1
      },
      bodyFont: {
          size: 17,  // 툴팁 본문 폰트 크기
          family: "'Pretendard'",
          lineHeight: 1,
      }
    },
    hover: {
        animationDuration: 400,
        axis: 'x',
        intersect: true,
        mode: 'label',
        onHover: null
    },
  },
  }

  // 날씨 라인차트 옵션
  export const weatherLine={
    responsive: true,
    maintainAspectRatio: false,
    animation: {
        duration: 2000
    },
    scales: {
        x: {
          grid: {
              drawOnChartArea: false // 이 축의 그리드 라인은 숨기기
          },
          ticks: {

              autoSkip: true,
              maxRotation: 0,
              minRotation: 0,
              display: true,
              padding: 3,
              font: {
                family: "'Pretendard'",
                size:15,
              }
          }
        },
        y: {
          // display:false,
          grid: {
              drawOnChartArea: false // 이 축의 그리드 라인은 숨기기
          },
          ticks: {
              callback: function(value) {
              // console.log(this.chart.data.datasets[0].label)
              // y1 축 데이터에 조건에 따라 단위 추가
              if (this.chart.data.datasets[0].label.includes('온도')) {
                return value + '℃';
              } else if (this.chart.data.datasets[0].label.includes('습도')) {
                return value + '%';
              } else if (this.chart.data.datasets[0].label.includes('강수확률')) {
                return value + '%';
              }  else if (this.chart.data.datasets[0].label.includes('풍속')) {
                return value + 'm/s';
              } else if (this.chart.data.datasets[0].label.includes('강수량')) {
                return value + 'mm';
              } 
            },
            // display:false,
            font: {
              family: "'Pretendard'",
              size:13
            }
          },
        },
    },
    interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false
        },
    elements: {
        line: {	/* 선 옵션 */
            borderCapStyle: 'round',
            borderDashOffset: 0,
            borderJoinStyle: 'round',	
            borderWidth: 3,
            capBezierPoints: true,
            fill: true,
            tension: 0
        },
        point: {	/* 표시자 옵션 */
            pointStyle: 'rectRounded',
            pointRadius: 0, 
            lineTension:1, 
            pointBorderWidth: 0, 
        },
    },
    plugins: {
      legend: {
          display: false,
          position: 'bottom',
          labels: {
            usePointStyle: true,

            font: {
              size:14,
              family: "'Pretendard'",
              lineHeight: 1
            },
          },

        },
        tooltip: {
          backgroundColor: 'rgba(0, 91, 150, 0.8)',  // 툴팁 배경색
          padding:20,
          titleFont: {
              size: 18,  // 툴팁 제목 폰트 크기
              family: "'Pretendard'",
              lineHeight: 1
          },
          bodyFont: {
              size: 17,  // 툴팁 본문 폰트 크기
              family: "'Pretendard'",
              lineHeight: 1,
          }
        },
        hover: {
            animationDuration: 400,
            axis: 'x',
            intersect: true,
            mode: 'label',
            onHover: null
        },
    },
}

// 바 stacked
export const BarStackOptions = {
  responsive: true,
  maintainAspectRatio: false,
  animation: {
      duration: 2000
  },
  maxBarThickness: 65, // 막대 굵기
  scales: {
      x: {
        grid: {
            drawOnChartArea: false // 이 축의 그리드 라인은 숨기기
        },
        stacked: true,
        ticks: {
            // 보이는 갯수 제한하기 autoSkip, maxTrickLimit 
            autoSkip: true,
            // maxTicksLimit:5,
            maxRotation: 0,
            minRotation: 0,
            display: true,
            padding: 5,
            font: {
              family: "'Pretendard'",
              size:15,
            }
        }
      },
      y: {
        ticks: {
          callback: function(value) {
            // y1 축 데이터에 조건에 따라 단위 추가
              return value + '두';
          },
          font: {
            family: "'Pretendard'",
            size:13
          }
        },
      },
  },
  interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
  },
  elements: {
      point: {	/* 표시자 옵션 */
          pointStyle: 'rectRounded',
          pointRadius: 0, 
          lineTension:1, 
          pointBorderWidth: 0, 
      },
  },
  plugins: {
    legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,

          font: {
            size:14,
            family: "'Pretendard'",
            lineHeight: 1
          },
        },

      },
      tooltip: {
        backgroundColor: 'rgba(0, 91, 150, 0.8)',  // 툴팁 배경색
        padding:20,
        titleFont: {
            size: 18,  // 툴팁 제목 폰트 크기
            family: "'Pretendard'",
            lineHeight: 1
        },
        bodyFont: {
            size: 17,  // 툴팁 본문 폰트 크기
            family: "'Pretendard'",
            lineHeight: 1,
        }
      },
      hover: {
          animationDuration: 400,
          axis: 'x',
          intersect: true,
          mode: 'label',
          onHover: null
      },
  },
}

export const CompareLineOptions = {
  responsive: true,
  maintainAspectRatio: false,
  // aspectRatio: 2, 
  animation: {
      duration: 2000
  },
  scales: {
      x: {
        grid: {
            drawOnChartArea: false // 이 축의 그리드 라인은 숨기기
        },
        ticks: {
            // 보이는 갯수 제한하기 autoSkip, maxTrickLimit 
            autoSkip: true,
            maxTicksLimit:5,
            maxRotation: 0,
            minRotation: 0,
            display: true,
            padding: 3,
            font: {
                size: 9,
            }
        }
      },
      'y1': {
          type: 'linear',
          position: 'left',
          // textStrokeWidth:100,
          ticks: {
              beginAtZero: true,
              suggestedMax: 100,
          },
          afterFit: function(scale) {
              scale.width = 40; // Set the desired width
          }
      },
      'y2': {
          type: 'linear',
          position: 'right',
          ticks: {
              beginAtZero: true,
              suggestedMax: 40,
              
          },
          title: {
              display: true,
          },
          grid: {
              drawOnChartArea: false // 이 축의 그리드 라인은 숨기기
          },
          afterFit: function(scale) {
              scale.width = 40; // Set the desired width
          }
      }
  },
  interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
      },
  elements: {
      line: {	/* 선 옵션 */
          borderCapStyle: 'round',
          borderDashOffset: 0,
          borderJoinStyle: 'round',	
          borderWidth: 3,
          capBezierPoints: true,
          // fill: true,
          tension: 0.4
      },
      point: {	/* 표시자 옵션 */
          pointStyle: 'rectRounded',
          pointRadius: 0, 
          lineTension:1, 
          pointBorderWidth: 0, 
      },
  },
  plugins: {
    legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0, 91, 150, 0.8)',  // 툴팁 배경색
        padding:20,
        titleFont: {
            size: 18,  // 툴팁 제목 폰트 크기
            family: "'Pretendard'",
            lineHeight: 1
        },
        bodyFont: {
            size: 17,  // 툴팁 본문 폰트 크기
            family: "'Pretendard'",
            lineHeight: 1,
        }
      },
      hover: {
          animationDuration: 400,
          axis: 'x',
          intersect: true,
          mode: 'label',
          onHover: null
      },
    }
}
// dailyChart
export const dailyLineOption = {
  elements: {
    line: {	/* 선 옵션 */
        borderCapStyle: 'round',	/* 선 마감: butt, round, square */
        borderDashOffset: 0,
        borderJoinStyle: 'round',	/* 꺾이는 부분 모양: miter, bevel, round */
        borderWidth: 3.0,
        capBezierPoints: true,
        fill: true,	/* 선 밑 공간 색으로 채우기 */
        tension: 0.4
    },
    point: {	/* 표시자 옵션 */
        pointStyle: 'circle',	/* circle, cross, corssRot, dash, line, rect, rectRounded, rectRot, start, triangle */
        pointRadius: 2, //point 없게 만들기 0으로 설정
        lineTension:1, //선 곡선모양 0이면 직선
        pointBorderWidth: 2, //포인터 보더사이즈
    },
  },
  plugins: {
    legend: {
        display: false,
    },
    tooltip: {
          ackgroundColor: 'rgba(0, 91, 150, 0.8)',  // 툴팁 배경색
          padding:20,
          titleFont: {
              size: 18,  // 툴팁 제목 폰트 크기
              family: "'Pretendard'",
              lineHeight: 1
          },
          bodyFont: {
              size: 17,  // 툴팁 본문 폰트 크기
              family: "'Pretendard'",
              lineHeight: 1,
          }
        },
    hover: {
        animationDuration: 400,
        axis: 'x',
        intersect: true,
        mode: 'label',
        onHover: null
    },
  },
  scales: {
    x: {
        grid: {
            display: true,
        },
        ticks: {
            display:true,
            padding: 3,
            font: {
                size: 12,
            }
        },
    },
    y: {
        afterFit(scale) {       // ticks 표시영역 폭 통일 
            scale.width = 50;
        },
        ticks: {
          callback: function(value) {
            // console.log(this.chart.data.datasets[0].label)
            // y1 축 데이터에 조건에 따라 단위 추가
            if (this.chart.data.datasets[0].label.includes('온도')) {
              return value + '℃';
            } else if (this.chart.data.datasets[0].label.includes('습도')) {
              return value + '%';
            } else if (this.chart.data.datasets[0].label.includes('이산화탄소')) {
              return value + 'ppm';
            }  else if (this.chart.data.datasets[0].label.includes('암모니아')) {
              return value + 'ppm';
            } else {
              return value + 'ppm';
            } 
          },
      
          
            display:true,
            padding: 5,
            font: {
                size: 10,
            }
        },
    // y축 스타일 지정
    grid: {
        drawBorder: true,
        color: "#e5e5e5",
        lineWidth: 1
    },
    fontSize:9,
    }
  },
}

export const CompareBarOption={
  responsive: true,
        aspectRatio: 1,
        maintainAspectRatio: false,
        animation: {
        duration: 2000
        },
        scales: {
        x: {
        grid: {
            drawOnChartArea: false // 이 축의 그리드 라인은 숨기기
        },
        ticks: {
            autoSkip: true,
            maxTicksLimit:8,
            maxRotation: 0,
            minRotation: 0,
            display: true,
            padding: 3,
            font: {
                family: "'Pretendard'",
                size:14,
            }
        }
        },
        'y1': {
                type: 'linear',
                position: 'left',
                // textStrokeWidth:100,
                ticks: {
                    display:false.a,
                    font: {
                        family: "'Pretendard'",
                        size:13
                    },
                    
                    beginAtZero: true,
                    suggestedMax: 100,
                },
                // afterFit: function(scale) {
                // scale.width = 40; // Set the desired width
                // }
        },
        'y2': {
                type: 'linear',
                position: 'right',
                ticks: {
                    display:false.a,
                    font: {
                        family: "'Pretendard'",
                        size:13
                    },
                    
                    beginAtZero: true,
                    suggestedMax: 100,
                },
                title: {
                display: true,
                },
                grid: {
                drawOnChartArea: false 
                },
                afterFit: function(scale) {
                scale.width = 40; // Set the desired width
                }
        }
    },
    interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false
        },
    elements: {
        line: {	/* 선 옵션 */
            borderCapStyle: 'round',
            borderDashOffset: 0,
            borderJoinStyle: 'round',	
            borderWidth: 3,
            capBezierPoints: true,
            // fill: true,
            tension: 0.4
        },
        point: {	/* 표시자 옵션 */
            pointStyle: 'rectRounded',
            pointRadius: 0, 
            lineTension:1, 
            pointBorderWidth: 0, 
        },
    },
    plugins: {
        zoom: {
            zoom: {
                drag: {
                    enabled: true
                },
                wheel: {
                    enabled: true,
                },
                pinch: {
                    enabled: true
                },
                mode: 'x',
                },
                animation: {
                    duration: 500,
                    easing: 'easeOutCubic'
                }
        },
        legend: {
            display: false,
        },
        tooltip: {
              backgroundColor: 'rgba(0, 91, 150, 0.8)',  // 툴팁 배경색
              padding:20,
              titleFont: {
                  size: 16,  // 툴팁 제목 폰트 크기
                  family: "'Pretendard'",
                  lineHeight: 1
              },
              bodyFont: {
                  size: 15,  // 툴팁 본문 폰트 크기
                  family: "'Pretendard'",
                  lineHeight: 1
              },
              callbacks: {
                label: function(tooltipItem) {
                    let label = tooltipItem.dataset.label || '';
                    let value = tooltipItem.raw;

                    // 온도 데이터인 경우에만 '℃'를 붙임
                    if (label.includes('온도')) {
                        value += '℃';
                    }else if(label.includes('습도')){
                        value += '%';
                    }else if(label.includes('기압')){
                        value += 'hPa';
                    }else if(label.includes('풍속')){
                        value += 'm/s';
                    }else{
                        value += 'kWh'
                    }

                    return label + ': ' + value;
                },
            },
        },
        hover: {
            animationDuration: 400,
            axis: 'x',
            intersect: true,
            mode: 'label',
            onHover: null
        },
    },
}